const LAST_SEEN_KEY = 'lastSeen';
export default function EquipmentFacetFiltersDirective() {
  return {
    restrict: 'E',
    template: require('./equipment-facet-filters.html'),
    scope: {
      queryString: '=',
      facets: '=',
      tags: '=?',
      tagFilters: '=',
      showMobile: '=?',
      onChange: '&',
      onLoaded: '&',
      onApplyClicked: '&',
      onClearClicked: '&',
      openclose: '&',
      filterCount: '=?',
    },
    controllerAs: 'vm',
    transclude: true,
    controller: EquipmentFacetFiltersController,
  };

  function EquipmentFacetFiltersController(
    $filter,
    $rootScope,
    $scope,
    $timeout,
    $uibModal,
    equipmentRepository,
    TimezoneService,
    gettextCatalog,
    $ngRedux,
    $state,
  ) {
    'ngInject';

    const vm = this;
    vm.store = $ngRedux;

    vm.closeFilters = closeFilters;
    vm.filterModels = newfilterModels();
    vm.onUpdateCommunicatedAt = onUpdateCommunicatedAt;
    vm.OnUpdateLastSeenFilter = OnUpdateLastSeenFilter;

    // private variable
    const reservedKeys = {
      lastCommKey: 'lastCommunicated',
      lastSeenKey: 'lastSeen',
      attrValueList: 'attrValueList',
      filtersCollection: 'filtersCollection',
    };

    const updateFilterCount = () => {
      const { alerts, maintenance, securityGroups, lastCommunicated, lastSeen } = vm.filterModels;
      const values = $scope.values;

      $scope.filterCount =
        alerts?.length +
        maintenance?.length +
        securityGroups?.length +
        lastCommunicated?.length +
        lastSeen?.length +
        Object.keys(values || {}).length;
    };

    const addToDataLayer = (data) => window.dataLayer.push(data);

    $scope.selectedTags = [];
    $scope.parsedTags = [];
    $scope.values = {};
    $scope.any = {};
    $scope.opened = {};
    $scope.focus = {};
    $scope.datetimedate = {};
    $scope.datetimeBounds = {};
    $scope.minMaxRequired = {};
    $scope.showTag = {};

    if (!$scope.tagFilters) {
      $scope.tagFilters = {};
    }

    $scope.search = {};
    $scope.style = {};

    $scope.dateOptions = {
      'year-format': "'yy'",
      'starting-day': 1,
    };

    // connect to store
    vm.$onInit = () => {
      vm.unsubscribe = vm.store.connect(vm.mapStateToThis, {})(vm);
      $scope.init();
    };
    vm.mapStateToThis = (state) => {
      const {
        user: { dateFormat = 'yyyy/MM/dd' },
      } = state;
      $scope.format = dateFormat.toLowerCase().replace(/m/g, 'M');
      $scope.dateTimeformat = `${$scope.format} h:mm:ss a`;
      return {
        format: dateFormat.toLowerCase().replace(/m/g, 'M'),
      };
    };
    vm.$onDestroy = () => {
      vm.unsubscribe();
    };
    // private function
    function newfilterModels() {
      const model = {
        alerts: [],
        securityGroups: [],
        maintenance: [],
        lastCommunicated: [],
        lastSeen: [],
      };
      return model;
    }

    function triggerSearch() {
      // updating toFilter in order to fire the watch
      $scope.toFilter = { ...($scope.toFilter || {}), facets: $scope.facets };

      updateFilterCount();
    }

    function onUpdateCommunicatedAt(option = null) {
      // If option is null, clear all selection
      $scope.facets.lastCommunicated.forEach((item) => {
        item._selected = option ? item.id === option.id : false;
      });

      vm.filterModels.lastCommunicated = option ? [option] : [];
      triggerSearch();
    }

    function OnUpdateLastSeenFilter(option) {
      // set  _selected for filters summary and filters counts
      const lastSeenfilter = option ? [{ ...option, _selected: true }] : [];
      $scope.facets.lastSeen = lastSeenfilter;
      vm.filterModels.lastSeen = lastSeenfilter;

      triggerSearch();
    }

    function closeFilters() {
      $scope.openclose();
    }

    // check to see if facets array is all selected
    $scope.allSelected = function (facets) {
      for (const key in facets) {
        if (!facets[key]._selected) {
          return false;
        }
      }
      return true;
    };

    $scope.toggleFacets = function (facets) {
      const facetValue = !$scope.allSelected(facets);

      for (const key in facets) {
        facets[key]._selected = facetValue;
      }
    };

    $scope.$watch('tagFilters', function (newVal, oldVal) {
      if (newVal !== oldVal) {
        refreshTagModels();
      }
    });

    $scope.$watch('facets', function (newVal, oldVal, updatedScope) {
      refreshFilterModels();
    });
    // Refresh the tag filters based on current facets
    function refreshFilterModels() {
      vm.filterModels = newfilterModels();
      for (const key in $scope.facets) {
        // Check to see if there is a matching facet key in the returned facets
        for (let i = 0; i < $scope.facets[key].length; i++) {
          const facet = $scope.facets[key][i];

          if (facet._selected) {
            vm.filterModels[key].push($scope.facets[key][i]);
          }
        }
      }
    }

    function refreshTagModels() {
      if (!$scope.tags) return;

      // Clear existing variables
      for (var i = 0; i < $scope.selectedTags.length; i++) {
        $scope.selectedTags[i].selected = false;
      }
      $scope.selectedTags = [];
      $scope.values = {};
      $scope.focus = {};
      $scope.any = {};
      $scope.showTag = [];

      for (var i = 0; i < $scope.tags.length; i++) {
        const { key } = $scope.tags[i];

        const selectedTag = $scope.tagFilters[$scope.tags[i].key];

        if (selectedTag !== undefined) {
          $scope.appendTag($scope.tags[i], false);

          if (selectedTag.hasOwnProperty('any')) {
            $scope.any[$scope.tags[i].id] = true;
            continue;
          }
          switch ($scope.tags[i].dataType) {
            case 'Text':
              $scope.values[$scope.tags[i].id] = {
                tag: $scope.tags[i].id,
                value: selectedTag,
              };
              break;
            case 'Integer':
              $scope.values[$scope.tags[i].id] = {
                tag: $scope.tags[i].id,
                value: selectedTag,
              };
              break;
            case 'Decimal':
              $scope.values[$scope.tags[i].id] = {
                tag: $scope.tags[i].id,
                value: selectedTag,
              };
              break;
            case 'Date':
              $scope.values[$scope.tags[i].id].tag = $scope.tags[i].id;
              if (selectedTag.min) {
                $scope.values[$scope.tags[i].id].value.min = new Date(
                  new Date(selectedTag.min).getTime() +
                    new Date(selectedTag.min).getTimezoneOffset() * 60000,
                );
                $scope.minMaxRequired[$scope.tags[i].id].min = true;
              }
              if (selectedTag.max) {
                $scope.values[$scope.tags[i].id].value.max = new Date(
                  new Date(selectedTag.max).getTime() +
                    new Date(selectedTag.max).getTimezoneOffset() * 60000,
                );
                $scope.minMaxRequired[$scope.tags[i].id].max = true;
              }
              break;
            case 'Datetime':
              $scope.values[$scope.tags[i].id].tag = $scope.tags[i].id;
              if (selectedTag.min) {
                const tempMin = selectedTag.min.replace(/\\/g, '').toUpperCase();
                $scope.values[$scope.tags[i].id].value.min = new Date(
                  new Date(tempMin).getTime() +
                    new Date(tempMin).getTimezoneOffset() * 60000 +
                    TimezoneService.getUserTimezoneOffset(new Date(tempMin)) * 60000,
                );
                $scope.datetimedate[$scope.tags[i].id].min =
                  $scope.values[$scope.tags[i].id].value.min;
                $scope.minMaxRequired[$scope.tags[i].id].min = true;
              }
              if (selectedTag.max) {
                const tempMax = selectedTag.max.replace(/\\/g, '').toUpperCase();
                $scope.values[$scope.tags[i].id].value.max = new Date(
                  new Date(tempMax).getTime() +
                    new Date(tempMax).getTimezoneOffset() * 60000 +
                    TimezoneService.getUserTimezoneOffset(new Date(tempMax)) * 60000,
                );
                $scope.datetimedate[$scope.tags[i].id].max =
                  $scope.values[$scope.tags[i].id].value.max;
                $scope.minMaxRequired[$scope.tags[i].id].max = true;
              }
              break;
          }
        }
      }
      $scope.toFilter = {
        facets: $scope.facets,
        tags: $scope.tagFilters,
      };
    }

    $scope.init = function () {
      $scope.loading = true;
      $scope.error = null;

      // If the facets is not

      equipmentRepository
        .getEquipmentFacets()
        .then(
          function (facets) {
            // Make sure that you use the existing facets
            const tempFacets = facets;

            if ($scope.facets) {
              for (const key in $scope.facets) {
                // Check to see if there is a matching facet key in the returned facets
                if (tempFacets[key]) {
                  for (let i = 0; i < $scope.facets[key].length; i++) {
                    const facet = $scope.facets[key][i];

                    for (let j = 0; j < tempFacets[key].length; j++) {
                      const tempFacet = tempFacets[key][j];

                      if (tempFacet.tag === facet.tag) {
                        tempFacet._selected = facet._selected;
                        vm.filterModels[key].push(tempFacet);
                        break;
                      }
                    }
                  }
                }
              }
              // Update with filters passed by parent
            }

            $scope.facets = tempFacets;
            $scope.facets._updatedBy = $scope.$id;

            return equipmentRepository.getAllTags();
          },
          function (response) {
            $scope.error = gettextCatalog.getString('Failed to load filters');
          },
        )
        .then(
          function (response) {
            if (!response) return null;

            $scope.tags = [];
            const {
              data: { data: allTags = [] },
            } = response;

            if (allTags) {
              allTags.forEach((tag) => {
                if (tag.dataType === 'Datetime') {
                  if (tag.range.min) {
                    tag.range.min = TimezoneService.tagToUserTimezone(tag.range.min);
                  }
                  if (tag.range.max) {
                    tag.range.max = TimezoneService.tagToUserTimezone(tag.range.max);
                  }
                }

                if (tag.dataType !== 'Hyperlink') {
                  $scope.tags.push(tag);
                }
              });
              // This is needed for asset type filtering.
              if (Object.keys($scope.tagFilters).length) {
                refreshTagModels();
                $scope.updateTags();
              }
            }
          },
          function (error) {
            $scope.error = gettextCatalog.getString('Failed to load filters');
          },
        )
        .finally(function () {
          $scope.loading = false;
          // Callback to let parent know we are done loading

          if ($scope.onLoaded) {
            $scope.onLoaded();
          }
        });
    };

    $scope.selectFacet = function (facet) {
      facet._selected = true;
    };

    $scope.deselectFacet = function (facet) {
      facet._selected = false;
    };

    $scope.appendTag = function (tag, focus) {
      $scope.selectedTags.push(tag);
      $scope.values[tag.id] = {
        tag: tag.id,
        value: {},
      };
      $scope.showTag[tag.id] = true;
      if (tag.dataType === 'Date' || tag.dataType === 'Datetime') {
        $scope.minMaxRequired[tag.id] = {
          min: false,
          max: false,
        };
      } else {
        $scope.values[tag.id].value = '';
      }
      if (tag.dataType === 'Date' || tag.dataType === 'Datetime') {
        $scope.opened[tag.id] = {
          min: false,
          max: false,
        };
        $scope.datetimedate[tag.id] = {};
        if (tag.freeform) {
          $scope.values[tag.id].value.min = new Date();
          $scope.values[tag.id].value.max = new Date();
          if (tag.dataType === 'Datetime') {
            $scope.values[tag.id].value.min = new Date(
              new Date().getTime() +
                new Date().getTimezoneOffset() * 60000 +
                TimezoneService.getUserTimezoneOffset(new Date()) * 60000,
            );
            $scope.values[tag.id].value.max = new Date(
              new Date().getTime() +
                new Date().getTimezoneOffset() * 60000 +
                TimezoneService.getUserTimezoneOffset(new Date()) * 60000,
            );
            $scope.datetimedate[tag.id].min = new Date(
              new Date($scope.values[tag.id].value.min).getTime() +
                new Date($scope.values[tag.id].value.min).getTimezoneOffset() * 60000 +
                TimezoneService.getUserTimezoneOffset(new Date($scope.values[tag.id].value.min)) *
                  60000,
            );
            $scope.datetimedate[tag.id].max = new Date(
              new Date($scope.values[tag.id].value.max).getTime() +
                new Date($scope.values[tag.id].value.max).getTimezoneOffset() * 60000 +
                TimezoneService.getUserTimezoneOffset(new Date($scope.values[tag.id].value.max)) *
                  60000,
            );
          }
        } else {
          if (tag.range.min) {
            $scope.values[tag.id].value.min = new Date(
              new Date(tag.range.min).getTime() +
                new Date(tag.range.min).getTimezoneOffset() * 60000,
            );
            if (tag.dataType === 'Datetime') {
              $scope.values[tag.id].value.min = new Date(
                new Date(tag.range.min).getTime() +
                  new Date(tag.range.min).getTimezoneOffset() * 60000 +
                  TimezoneService.getUserTimezoneOffset(new Date(tag.range.min)) * 60000,
              );
              $scope.datetimedate[tag.id].min = new Date(
                new Date(tag.range.min).getTime() +
                  new Date(tag.range.min).getTimezoneOffset() * 60000 +
                  TimezoneService.getUserTimezoneOffset(new Date(tag.range.min)) * 60000,
              );
              $scope.values[tag.id].minValue = new Date(
                new Date(tag.range.min).getTime() +
                  new Date(tag.range.min).getTimezoneOffset() * 60000 +
                  TimezoneService.getUserTimezoneOffset(new Date(tag.range.min)) * 60000,
              );
            }
          }
          if (tag.range.max) {
            $scope.values[tag.id].value.max = new Date(
              new Date(tag.range.max).getTime() +
                new Date(tag.range.max).getTimezoneOffset() * 60000,
            );

            if (tag.dataType === 'Datetime') {
              $scope.values[tag.id].value.max = new Date(
                new Date(tag.range.max).getTime() +
                  new Date(tag.range.max).getTimezoneOffset() * 60000 +
                  TimezoneService.getUserTimezoneOffset(new Date(tag.range.max)) * 60000,
              );
              $scope.datetimedate[tag.id].max = new Date(
                new Date(tag.range.max).getTime() +
                  new Date(tag.range.max).getTimezoneOffset() * 60000 +
                  TimezoneService.getUserTimezoneOffset(new Date(tag.range.max)) * 60000,
              );
              $scope.values[tag.id].maxValue = new Date(
                new Date(tag.range.max).getTime() +
                  new Date(tag.range.max).getTimezoneOffset() * 60000 +
                  TimezoneService.getUserTimezoneOffset(new Date(tag.range.max)) * 60000,
              );
            }
          }
          $scope.datetimeBounds[tag.id] = {
            maxStart: $scope.returnTimeBound('maxStart', tag.id),
            minStart: $scope.returnTimeBound('minStart', tag.id),
            maxEnd: $scope.returnTimeBound('maxEnd', tag.id),
            minEnd: $scope.returnTimeBound('minEnd', tag.id),
          };
        }
      }
      tag.selected = true;
      $scope.newTag = {};
      if (focus) {
        $scope.focus[tag.id] = true;
        $scope.style[tag.id] = {};
        $scope.showTag[tag.id] = true;
      } else {
        $scope.focus[tag.id] = false;
        $scope.style[tag.id] = {
          cursor: 'pointer',
        };
        $scope.showTag[tag.id] = false;
      }
    };

    $scope.removeTag = function (index) {
      $scope.selectedTags[index].selected = false;
      delete $scope.values[$scope.selectedTags[index].id];
      delete $scope.any[$scope.selectedTags[index].id];
      delete $scope.focus[$scope.selectedTags[index].id];
      delete $scope.style[$scope.selectedTags[index].id];
      delete $scope.showTag[$scope.selectedTags[index].id];
      $scope.selectedTags.splice(index, 1);

      $timeout(function () {
        $scope.applyTags();
      }, 1);
    };

    $scope.blurOnSelect = function (selectedItem) {
      $timeout(function () {
        $(':focus').blur();
      }, 1);
    };

    $scope.toggle = function (index) {
      $scope.showTag[index] = !$scope.showTag[index];
      if ($scope.showTag[index]) {
        $scope.style[index] = {};
      } else {
        $scope.style[index] = {
          cursor: 'pointer',
        };
      }
    };

    $scope.show = function (index) {
      $scope.showTag[index] = true;
      $scope.style[index] = {};
      $scope.focus[index] = true;
    };

    $scope.hide = function (index, e) {
      if (e) {
        const { target } = e;
        $timeout(function () {
          target.blur();
        }, 1);
      }
      $scope.showTag[index] = false;
      $scope.style[index] = {
        cursor: 'pointer',
      };
      $scope.focus[index] = false;
    };

    $scope.showIfHidden = function (index) {
      event.stopPropagation();
      if (!$scope.showTag[index]) {
        $scope.show(index);
      }
    };

    $scope.filterSelected = function (tag) {
      if (tag.selected) {
        return false;
      }
      return true;
    };

    $scope.roundInt = function (val) {
      return val ? Math.floor(val) : val;
    };

    $scope.open = function (index, val) {
      if (val === 'min') {
        $scope.opened[index].min = true;
      } else if (val === 'max') {
        $scope.opened[index].max = true;
      }
    };

    $scope.datetimeValidCheck = function (id, val) {
      let temp;
      if (val === 'min') {
        if (!$scope.minMaxRequired[id].min) {
          return true;
        }
        temp = new Date($scope.datetimedate[id].min.getTime());
        if ($scope.values[id].value.min) {
          temp.setHours($scope.values[id].value.min.getHours());
          temp.setMinutes($scope.values[id].value.min.getMinutes());
          temp.setSeconds($scope.values[id].value.min.getSeconds());
        }
      } else if (val === 'max') {
        if (!$scope.minMaxRequired[id].max) {
          return true;
        }
        temp = new Date($scope.datetimedate[id].max.getTime());
        if ($scope.values[id].value.max) {
          temp.setHours($scope.values[id].value.max.getHours());
          temp.setMinutes($scope.values[id].value.max.getMinutes());
          temp.setSeconds($scope.values[id].value.max.getSeconds());
        }
      }

      if (
        (!$scope.values[id].minValue || temp >= $scope.values[id].minValue) &&
        (!$scope.values[id].maxValue || temp <= $scope.values[id].maxValue)
      ) {
        return true;
      }
      return false;
    };

    $scope.rangeValid = function (id) {
      if (
        $scope.minMaxRequired[id].min &&
        $scope.minMaxRequired[id].max &&
        $scope.values[id].value.min > $scope.values[id].value.max
      ) {
        return false;
      }
      return true;
    };

    $scope.rangeDefined = function (id) {
      if (!$scope.minMaxRequired[id].min && !$scope.minMaxRequired[id].max && !$scope.any[id]) {
        return false;
      }
      return true;
    };

    $scope.datetimeRangeValid = function (id) {
      if (
        $scope.minMaxRequired[id].min &&
        $scope.minMaxRequired[id].max &&
        $scope.datetimedate[id].min &&
        $scope.datetimedate[id].max
      ) {
        const tempMin = new Date($scope.datetimedate[id].min.getTime());
        if ($scope.values[id].value.min) {
          tempMin.setHours($scope.values[id].value.min.getHours());
          tempMin.setMinutes($scope.values[id].value.min.getMinutes());
          tempMin.setSeconds($scope.values[id].value.min.getSeconds());
        }
        const tempMax = new Date($scope.datetimedate[id].max.getTime());
        if ($scope.values[id].value.max) {
          tempMax.setHours($scope.values[id].value.max.getHours());
          tempMax.setMinutes($scope.values[id].value.max.getMinutes());
          tempMax.setSeconds($scope.values[id].value.max.getSeconds());
        }
        return tempMin <= tempMax;
      }
      return true;
    };

    $scope.updateTimeBounds = function (key, id) {
      switch (key) {
        case 'start':
          $scope.datetimeBounds[id].minStart = $scope.returnTimeBound('minStart', id);
          $scope.datetimeBounds[id].maxStart = $scope.returnTimeBound('maxStart', id);
          break;
        case 'end':
          $scope.datetimeBounds[id].minEnd = $scope.returnTimeBound('minEnd', id);
          $scope.datetimeBounds[id].maxEnd = $scope.returnTimeBound('maxEnd', id);
          break;
      }
    };

    $scope.returnTimeBound = function (key, id) {
      switch (key) {
        case 'maxStart':
          if (!$scope.datetimedate[id].min || !$scope.values[id].maxValue) {
            return undefined;
          }
          if (
            $scope.datetimedate[id].min.toDateString() === $scope.values[id].maxValue.toDateString()
          ) {
            var tempMax = new Date($scope.values[id].value.min.getTime());
            if ($scope.values[id].value.min) {
              tempMax.setHours($scope.values[id].maxValue.getHours());
              tempMax.setMinutes($scope.values[id].maxValue.getMinutes());
              tempMax.setSeconds($scope.values[id].maxValue.getSeconds());
            }
            return tempMax;
          }
          return undefined;

          break;
        case 'minStart':
          if (!$scope.datetimedate[id].min || !$scope.values[id].minValue) {
            return undefined;
          }
          if (
            $scope.datetimedate[id].min.toDateString() === $scope.values[id].minValue.toDateString()
          ) {
            var tempMin = new Date($scope.values[id].value.min.getTime());
            if ($scope.values[id].value.min) {
              tempMin.setHours($scope.values[id].minValue.getHours());
              tempMin.setMinutes($scope.values[id].minValue.getMinutes());
              tempMin.setSeconds($scope.values[id].minValue.getSeconds());
            }
            return tempMin;
          }
          return undefined;

          break;
        case 'minEnd':
          if (!$scope.datetimedate[id].max || !$scope.values[id].minValue) {
            return undefined;
          }
          if (
            $scope.datetimedate[id].max.toDateString() === $scope.values[id].minValue.toDateString()
          ) {
            var tempMin = new Date($scope.values[id].value.max.getTime());
            if ($scope.values[id].value.max) {
              tempMin.setHours($scope.values[id].minValue.getHours());
              tempMin.setMinutes($scope.values[id].minValue.getMinutes());
              tempMin.setSeconds($scope.values[id].minValue.getSeconds());
            }
            return tempMin;
          }
          return undefined;

          break;
        case 'maxEnd':
          if (!$scope.datetimedate[id].max || !$scope.values[id].maxValue) {
            return undefined;
          }
          if (
            $scope.datetimedate[id].max.toDateString() === $scope.values[id].maxValue.toDateString()
          ) {
            var tempMax = new Date($scope.values[id].value.max.getTime());
            if ($scope.values[id].value.max) {
              tempMax.setHours($scope.values[id].maxValue.getHours());
              tempMax.setMinutes($scope.values[id].maxValue.getMinutes());
              tempMax.setSeconds($scope.values[id].maxValue.getSeconds());
            }
            return tempMax;
          }
          return undefined;

          break;
      }
    };

    $scope.generateTooltip = function (tag) {
      let tip = '';
      switch (tag.dataType) {
        case 'Integer':
          tip = gettextCatalog.getString('Enter an integer ');
          if (tag.range.min) {
            if (!tag.range.max) {
              tip += gettextCatalog.getString('(minimum {{min}})', {
                min: tag.range.min,
              });
            } else {
              tip += gettextCatalog.getString('from {{min}} to ', {
                min: tag.range.min,
              });
            }
          }
          if (tag.range.max) {
            if (!tag.range.min) {
              tip += gettextCatalog.getString('(maximum {{max}})', {
                max: tag.range.max,
              });
            } else {
              tip += tag.range.max;
            }
          }
          return tip;
          break;
        case 'Decimal':
          tip = gettextCatalog.getString('Enter a number ');
          if (tag.range.min) {
            if (!tag.range.max) {
              tip += gettextCatalog.getString('(minimum {{min}})', {
                min: tag.range.min,
              });
            } else {
              tip += gettextCatalog.getString('from {{min}} to ', {
                min: tag.range.min,
              });
            }
          }
          if (tag.range.max) {
            if (!tag.range.min) {
              tip += gettextCatalog.getString('(maximum {{max}})', {
                max: tag.range.max,
              });
            } else {
              tip += tag.range.max;
            }
          }
          return tip;
          break;
        case 'Date':
          tip = gettextCatalog.getString('Select a date ');
          if (tag.range.min) {
            if (!tag.range.max) {
              tip += gettextCatalog.getString('({{min}} or later)', {
                min: $filter('date')(tag.range.min, $scope.format),
              });
            } else {
              tip += gettextCatalog.getString('from {{min}} to ', {
                min: $filter('date')(tag.range.min, $scope.format),
              });
            }
          }
          if (tag.range.max) {
            if (!tag.range.min) {
              tip += gettextCatalog.getString('({{max}} or earlier)', {
                max: $filter('date')(tag.range.max, $scope.format),
              });
            } else {
              tip += $filter('date')(tag.range.max, $scope.format);
            }
          }
          return tip;
          break;
        case 'Datetime':
          tip = gettextCatalog.getString('Select a date and time ');
          if (tag.range.min) {
            if (!tag.range.max) {
              tip += gettextCatalog.getString('({{min}} or later)', {
                min: $filter('date')(tag.range.min, $scope.dateTimeformat),
              });
            } else {
              tip += gettextCatalog.getString('from {{min}} to ', {
                min: $filter('date')(tag.range.min, $scope.dateTimeformat),
              });
            }
          }
          if (tag.range.max) {
            if (!tag.range.min) {
              tip += gettextCatalog.getString('({{max}} or earlier)', {
                max: $filter('date')(tag.range.max, $scope.dateTimeformat),
              });
            } else {
              tip += $filter('date')(tag.range.max, $scope.dateTimeformat);
            }
          }
          return tip;
          break;
      }
    };

    $scope.displayValue = function (tag) {
      if ($scope.any[tag.id]) {
        return '(any)';
      }

      switch (tag.dataType) {
        case 'Text':
          if (!$scope.values[tag.id].value || $scope.values[tag.id].value.length === 0) {
            return '';
          }
          var val = $scope.values[tag.id].value[0];
          var output = val !== null && typeof val === 'object' ? val.text : val;
          for (var i = 1; i < $scope.values[tag.id].value.length; i++) {
            val = $scope.values[tag.id].value[i];
            val = val !== null && typeof val === 'object' ? val.text : val;
            output += ` <i>${gettextCatalog.getString('OR')}</i> ${val}`;
          }
          return output;

          break;
        case 'Integer':
          if (!$scope.values[tag.id].value || $scope.values[tag.id].value.length === 0) {
            return '';
          }
          var output = $scope.values[tag.id].value[0].text;
          for (var i = 1; i < $scope.values[tag.id].value.length; i++) {
            output += ` <i>${gettextCatalog.getString('OR')}</i> ${
              $scope.values[tag.id].value[i].text
            }`;
          }
          return output;

          break;
        case 'Decimal':
          if (!$scope.values[tag.id].value || $scope.values[tag.id].value.length === 0) {
            return '';
          }
          var output = $scope.values[tag.id].value[0].text;
          for (var i = 1; i < $scope.values[tag.id].value.length; i++) {
            output += ` <i>${gettextCatalog.getString('OR')}</i> ${
              $scope.values[tag.id].value[i].text
            }`;
          }
          return output;
          break;
        case 'Date':
          var text = '';
          if ($scope.values[tag.id].value.min && $scope.minMaxRequired[tag.id].min) {
            if (!($scope.values[tag.id].value.max && $scope.minMaxRequired[tag.id].max)) {
              text += gettextCatalog.getString('{{min}} or later', {
                min: $filter('date')($scope.values[tag.id].value.min, $scope.format),
              });
              return text;
            }
            text += gettextCatalog.getString('From {{min}} to ', {
              min: $filter('date')($scope.values[tag.id].value.min, $scope.format),
            });
          }
          if ($scope.values[tag.id].value.max && $scope.minMaxRequired[tag.id].max) {
            if (!($scope.values[tag.id].value.min && $scope.minMaxRequired[tag.id].min)) {
              text += gettextCatalog.getString('{{max}} or earlier', {
                max: $filter('date')($scope.values[tag.id].value.max, $scope.format),
              });
            } else {
              text += $filter('date')($scope.values[tag.id].value.max, $scope.format);
            }
            return text;
          }
          return '';
          break;
        case 'Datetime':
          var text = '';
          if (
            $scope.values[tag.id].value.min &&
            $scope.datetimedate[tag.id].min &&
            $scope.minMaxRequired[tag.id].min
          ) {
            var temp = new Date($scope.datetimedate[tag.id].min.getTime());
            temp.setHours($scope.values[tag.id].value.min.getHours());
            temp.setMinutes($scope.values[tag.id].value.min.getMinutes());
            temp.setSeconds($scope.values[tag.id].value.min.getSeconds());
            if (
              !(
                $scope.values[tag.id].value.max &&
                $scope.datetimedate[tag.id].max &&
                $scope.minMaxRequired[tag.id].max
              )
            ) {
              text += gettextCatalog.getString('{{min}} or later', {
                min: $filter('date')(temp, $scope.dateTimeformat),
              });
              return text;
            }
            text += gettextCatalog.getString('From {{min}} to ', {
              min: $filter('date')(temp, $scope.dateTimeformat),
            });
          }
          if ($scope.values[tag.id].value.max && $scope.minMaxRequired[tag.id].max) {
            var temp = new Date($scope.datetimedate[tag.id].max.getTime());
            temp.setHours($scope.values[tag.id].value.max.getHours());
            temp.setMinutes($scope.values[tag.id].value.max.getMinutes());
            temp.setSeconds($scope.values[tag.id].value.max.getSeconds());
            if (!($scope.values[tag.id].value.min && $scope.minMaxRequired[tag.id].min)) {
              text += gettextCatalog.getString('{{max}} or earlier', {
                max: $filter('date')(temp, $scope.dateTimeformat),
              });
            } else {
              text += $filter('date')(temp, $scope.dateTimeformat);
            }
            return text;
          }
          return '';
          break;
      }
    };

    $scope.$watch(
      'toFilter',
      function (newValue, oldValue) {
        if (newValue != oldValue) {
          $rootScope.$broadcast('map-filter-update');
          $scope.showMobile = false;
          $scope.onChange();
          for (const key in $scope.focus) {
            $scope.focus[key] = false;
          }

          if (newValue !== undefined) {
            const eventData = {};
            let arr;

            if (newValue.facets !== undefined) {
              if (newValue.facets.alerts !== undefined) {
                arr = newValue.facets.alerts
                  .filter((item) => item._selected === true)
                  .map((item) => item.name);

                if (arr.length > 0) eventData.alertPriority = arr;
              }

              if (newValue.facets.maintenance !== undefined) {
                arr = newValue.facets.maintenance
                  .filter((item) => item._selected === true)
                  .map((item) => item.name);

                if (arr.length > 0) eventData.maintenance = arr;
              }

              if (newValue.facets.securityGroups !== undefined) {
                arr = newValue.facets.securityGroups
                  .filter((item) => item._selected === true)
                  .map((item) => item.name);

                if (arr.length > 0) eventData.securityGroups = arr;
              }

              if (newValue.facets.lastCommunicated !== undefined) {
                arr = newValue.facets.lastCommunicated
                  .filter((item) => item._selected === true)
                  .map((item) => item.id);

                if (arr.length > 0) eventData.lastCommunicated = arr;
              }

              if (newValue.facets.lastSeen !== undefined) {
                arr = newValue.facets.lastSeen
                  .filter((item) => item._selected === true)
                  .map((item) => ({ id: item.id, range: item.range }));

                if (arr.length > 0) eventData.lastSeen = arr;
              }
            }

            if (newValue.tags !== undefined && Object.keys(newValue.tags).length > 0) {
              eventData.tags = newValue.tags;
            }

            eventData.page = $state.current.name;

            addToDataLayer({
              event: 'assetsFacetFiltering',
              data: eventData,
            });
          }
        }
      },
      true,
    );

    $scope.isNotSelected = function (item) {
      return !item._selected;
    };

    $scope.tagsValid = function () {
      for (let i = 0; i < $scope.selectedTags.length; i++) {
        if (Array.isArray($scope.values[$scope.selectedTags[i].id].value)) {
          if (
            $scope.values[$scope.selectedTags[i].id].value.length == 0 &&
            !$scope.any[$scope.selectedTags[i].id]
          ) {
            return false;
          }
        }
        switch ($scope.selectedTags[i].dataType) {
          case 'Text':
            if (
              (!$scope.values[$scope.selectedTags[i].id].value ||
                $scope.values[$scope.selectedTags[i].id].value === '') &&
              !$scope.any[$scope.selectedTags[i].id]
            ) {
              return false;
            }
            break;
          case 'Integer':
            if (
              (!$scope.values[$scope.selectedTags[i].id].value ||
                $scope.values[$scope.selectedTags[i].id].value === '') &&
              !$scope.any[$scope.selectedTags[i].id]
            ) {
              return false;
            }
            break;
          case 'Decimal':
            if (
              (!$scope.values[$scope.selectedTags[i].id].value ||
                $scope.values[$scope.selectedTags[i].id].value === '') &&
              !$scope.any[$scope.selectedTags[i].id]
            ) {
              return false;
            }
            break;
          case 'Date':
            if (
              !$scope.rangeValid($scope.selectedTags[i].id) ||
              !$scope.rangeDefined($scope.selectedTags[i].id)
            ) {
              return false;
            }
            break;
          case 'Datetime':
            if (
              !$scope.datetimeRangeValid($scope.selectedTags[i].id) ||
              !$scope.rangeDefined($scope.selectedTags[i].id)
            ) {
              return false;
            }
            break;
        }
      }
      return true;
    };

    $scope.validInteger = function (input, tag) {
      if (isNaN(input.text)) {
        return false;
      }

      const num = parseInt(input.text, 10);
      tag.value = num;

      if (!$scope.tagFilters[tag.key] || $scope.tagFilters[tag.key].length == 0) {
        $scope.tagFilters[tag.key] = [];
      }

      $scope.tagFilters[tag.key].push(tag.value);
      if (num !== parseFloat(input.text)) {
        return false;
      }

      if (tag.range.min) {
        if (num < tag.range.min) {
          return false;
        }
      }

      if (tag.range.max) {
        if (num > tag.range.max) {
          return false;
        }
      }

      return true;
    };

    $scope.validDecimal = function (input, tag) {
      if (isNaN(input.text)) {
        return false;
      }
      const num = parseFloat(input.text);
      tag.value = num;
      if (!$scope.tagFilters[tag.key] || $scope.tagFilters[tag.key].length == 0) {
        $scope.tagFilters[tag.key] = [];
      }
      $scope.tagFilters[tag.key].push(tag.value);
      if (tag.range.min) {
        if (num < tag.range.min) {
          return false;
        }
      }
      if (tag.range.max) {
        if (num > tag.range.max) {
          return false;
        }
      }
      return true;
    };

    $scope.updateTags = function () {
      $scope.tagFilters = {};
      // $scope.tagFilters._updatedBy = $scope.$id;
      for (let i = 0; i < $scope.selectedTags.length; i++) {
        if ($scope.any[$scope.selectedTags[i].id]) {
          $scope.tagFilters[$scope.selectedTags[i].key] = {
            any: true,
          };
          continue;
        }
        if (
          $scope.selectedTags[i].dataType === 'Integer' ||
          $scope.selectedTags[i].dataType === 'Decimal'
        ) {
          $scope.tagFilters[$scope.selectedTags[i].key] = [];
          for (let j = 0; j < $scope.values[$scope.selectedTags[i].id].value.length; j++) {
            $scope.tagFilters[$scope.selectedTags[i].key].push(
              $scope.values[$scope.selectedTags[i].id].value[j].text,
            );
          }
          continue;
        }
        $scope.tagFilters[$scope.selectedTags[i].key] = angular.copy(
          $scope.values[$scope.selectedTags[i].id].value,
        );
        if (
          $scope.values[$scope.selectedTags[i].id].value.hasOwnProperty('min') &&
          !$scope.minMaxRequired[$scope.selectedTags[i].id].min
        ) {
          delete $scope.tagFilters[$scope.selectedTags[i].key].min;
        }
        if (
          $scope.tagFilters[$scope.selectedTags[i].key].hasOwnProperty('min') &&
          $scope.selectedTags[i].dataType === 'Date'
        ) {
          $scope.tagFilters[$scope.selectedTags[i].key].min = $filter('date')(
            $scope.tagFilters[$scope.selectedTags[i].key].min,
            'yyyy-MM-dd',
          );
        }
        if (
          $scope.tagFilters[$scope.selectedTags[i].key].hasOwnProperty('min') &&
          $scope.selectedTags[i].dataType === 'Datetime'
        ) {
          var temp = new Date($scope.datetimedate[$scope.selectedTags[i].id].min.getTime());
          var tagDate = new Date($scope.tagFilters[$scope.selectedTags[i].key].min);
          temp.setHours(tagDate.getHours());
          temp.setMinutes(tagDate.getMinutes());
          temp.setSeconds(tagDate.getSeconds());
          temp = new Date(
            new Date(temp).getTime() -
              new Date(temp).getTimezoneOffset() * 60000 -
              TimezoneService.getUserTimezoneOffset(new Date(temp)) * 60000,
          );
          $scope.tagFilters[$scope.selectedTags[i].key].min = $filter('searchFormat')(
            temp.toISOString(),
          );
        }
        if (
          $scope.values[$scope.selectedTags[i].id].value.hasOwnProperty('max') &&
          !$scope.minMaxRequired[$scope.selectedTags[i].id].max
        ) {
          delete $scope.tagFilters[$scope.selectedTags[i].key].max;
        }
        if (
          $scope.tagFilters[$scope.selectedTags[i].key].hasOwnProperty('max') &&
          $scope.selectedTags[i].dataType === 'Date'
        ) {
          $scope.tagFilters[$scope.selectedTags[i].key].max = $filter('date')(
            $scope.tagFilters[$scope.selectedTags[i].key].max,
            'yyyy-MM-dd',
          );
        }
        if (
          $scope.tagFilters[$scope.selectedTags[i].key].hasOwnProperty('max') &&
          $scope.selectedTags[i].dataType === 'Datetime'
        ) {
          var temp = new Date($scope.datetimedate[$scope.selectedTags[i].id].max.getTime());
          var tagDate = new Date($scope.tagFilters[$scope.selectedTags[i].key].max);
          temp.setHours(tagDate.getHours());
          temp.setMinutes(tagDate.getMinutes());
          temp.setSeconds(tagDate.getSeconds());
          temp = new Date(
            new Date(temp).getTime() -
              new Date(temp).getTimezoneOffset() * 60000 -
              TimezoneService.getUserTimezoneOffset(new Date(temp)) * 60000,
          );
          $scope.tagFilters[$scope.selectedTags[i].key].max = $filter('searchFormat')(
            temp.toISOString(),
          );
        }
      }

      $scope.toFilter = {
        facets: $scope.facets,
        tags: $scope.tagFilters,
      };
    };

    /**
     * this function will get called every time we click on any spot in the filter
     * as will as been used to trigger the search after any update to facet or tags by updating
     * $scope.toFilter then toFilter watcher will fire the event to do the search.
     * - there is no button to apply an attribute, therefore we check the changes when clicking outside the attr or by press enter.
     * - make the global applyTags event go through only when there are tags(attrs) changes.
     */
    $scope.applyTags = function (globalEventTag) {
      $scope.search.form.$setSubmitted();

      const hasTagsSelected = ($scope.selectedTags || []).length > 0;
      const anyTagsApplied = Object.keys($scope.tagFilters || {}).length > 0;
      const is_globel_with_no_tagsFiters_changes =
        globalEventTag === 'global' && !hasTagsSelected && !anyTagsApplied;

      if (
        $scope.search.form.$invalid ||
        !$scope.tagsValid() ||
        is_globel_with_no_tagsFiters_changes
      ) {
        return;
      }

      updateFilterCount();
      $scope.updateTags();
    };

    $scope.clearFilters = function () {
      for (let i = 0; i < $scope.selectedTags.length; i++) {
        $scope.selectedTags[i].selected = false;
      }

      $scope.selectedTags = [];
      for (const key in $scope.facets) {
        if (key === LAST_SEEN_KEY) {
          $scope.facets[key] = [];
        }
        for (let j = 0; j < $scope.facets[key].length; j++) {
          $scope.facets[key][j]._selected = false;
        }
      }
      $scope.queryString = '';
      $scope.values = {};
      $scope.focus = {};
      $scope.any = {};
      vm.filterModels = newfilterModels();
      $scope.applyTags();
    };

    // Load Saved Filters
    $scope.loadSavedFilters = function () {
      const modalInstance = $uibModal.open({
        animation: true,
        bindToController: true,
        template: require('../savedfilters/saved-filters-modal.html'),
        controller: 'SavedFiltersModalController',
        resolve: {},
        size: 'md',
        windowClass: 'tr-saved-filters-modal-dismiss',
      });

      // modal dialog result
      modalInstance.result.then(
        function (selectedFilters) {
          // $scope.clearFilters();
          const selectedFilterModels = {};
          selectedFilterModels.alerts = selectedFilters.alertStates;
          selectedFilterModels.maintenance = selectedFilters.maintenanceStates;
          selectedFilterModels.securityGroups = selectedFilters.securityGroupIds;
          selectedFilterModels.attrValueList = selectedFilters.attrValueList;
          selectedFilterModels.filtersCollection = selectedFilters.filtersCollection; // ['lastCommunicated'];
          $scope.selectedTagFilters = selectedFilters.attrValueList;

          vm.filterModels = newfilterModels();

          Object.keys(selectedFilterModels).forEach((key) => {
            // Check to see if there is a matching facet key in the returned facets
            if (
              $scope.facets[key] &&
              key !== reservedKeys.attrValueList &&
              key !== reservedKeys.filtersCollection
            ) {
              for (let i = 0; i < selectedFilterModels[key].length; i++) {
                const facet = selectedFilterModels[key][i];
                for (let j = 0; j < $scope.facets[key].length; j++) {
                  const tempFacet = $scope.facets[key][j];
                  if (tempFacet.tag === facet) {
                    tempFacet._selected = true;
                    vm.filterModels[key].push(tempFacet);
                    break;
                  } // end if
                } // end inner most for
              } // end inner for

              for (let i = 0; i < $scope.facets[key].length; i++) {
                if (vm.filterModels[key].indexOf($scope.facets[key][i]) < 0) {
                  $scope.facets[key][i]._selected = false;
                }
              }
            } // end if
          });

          // Update with filters passed by parent
          updateTagsForFilter(selectedFilterModels); // AttrsValueList
          // update with filterscollection
          updateFilterCollection(selectedFilterModels);

          $scope.queryString = selectedFilters.queryString;
          $scope.facets._updatedBy = $scope.$id;

          updateFilterCount();
        },
        function (error) {},
      ); // end modalInstance result
    }; // end loadSavedFilters()

    function updateTagsForFilter(selectedFilterModels) {
      $scope.selectedTagFilters = selectedFilterModels.attrValueList;
      if ($scope.selectedTagFilters.length == 0) return;
      if (!$scope.tags) return;
      // Clear existing variables
      $scope.values = {};
      $scope.focus = {};
      $scope.any = {};
      $scope.showTag = [];
      $scope.selectedTags = [];
      // $scope.minMaxRequired = {};
      for (const key in $scope.selectedTagFilters) {
        var selectedTagFilter = $scope.selectedTagFilters[key];
        for (let i = 0; i < $scope.tags.length; i++) {
          var tag = $scope.tags[i];
          if (key === tag.id) {
            tag.selected = true;
            $scope.selectedTags.push(tag);
            $scope.values[tag.id] = {
              tag: tag.id,
              value: (function () {
                const values = selectedTagFilter;
                if (tag.dataType === 'Datetime') {
                  if (values.min) {
                    const tempMin = values.min;
                    values.min = new Date(
                      new Date(tempMin).getTime() +
                        new Date(tempMin).getTimezoneOffset() * 60000 +
                        TimezoneService.getUserTimezoneOffset(new Date(tempMin)) * 60000,
                    );
                  }
                  if (values.max) {
                    const tempMax = values.max;
                    values.max = new Date(
                      new Date(tempMax).getTime() +
                        new Date(tempMax).getTimezoneOffset() * 60000 +
                        TimezoneService.getUserTimezoneOffset(new Date(tempMax)) * 60000,
                    );
                  }
                }
                return values;
              })(),
            };

            $scope.any[tag.id] = $scope.values[tag.id].value.any;
            if (Array.isArray($scope.values[tag.id].value)) {
              for (let m = 0; m < $scope.values[tag.id].value.length; m++) {
                const val = $scope.values[tag.id].value[m];
                if (tag.dataType === 'Text') {
                  $scope.values[tag.id].value[m] = val;
                  $scope.values[tag.id].value[m] = val;
                } else {
                  $scope.values[tag.id].value[m] = {};
                  $scope.values[tag.id].value[m].text = val;
                }
              }
            }
            $scope.minMaxRequired[tag.id] = {};
            $scope.datetimedate[tag.id] = {};
            $scope.minMaxRequired[tag.id].min = $scope.values[tag.id].value.min;
            $scope.minMaxRequired[tag.id].max = $scope.values[tag.id].value.max;
            $scope.datetimedate[tag.id].min = new Date($scope.values[tag.id].value.min);
            $scope.datetimedate[tag.id].max = new Date($scope.values[tag.id].value.max);
            break;
          } // end if
        } // end inner for
      } // end outer for
      $scope.updateTags();
    } // end updateTagsForFilter

    // Create Saved Filter
    $scope.saveFiltersAs = function () {
      vm.filterModels.queryString = $scope.queryString;
      const modalInstance = $uibModal.open({
        animation: true,
        bindToController: true,
        template: require('../savedfilters/save-filters-modal.html'),
        controller: 'SaveFiltersModalController',
        controllerAs: 'vm',
        resolve: {
          filterModels() {
            return vm.filterModels;
          },
          selectedTags() {
            return $scope.selectedTags;
          },
          tagFilters() {
            return $scope.tagFilters;
          },
        },
        size: 'md',
      });

      // modal dialog result
      modalInstance.result.then(
        function (savedFilters) {
          $scope.savedFilters = savedFilters;
        },
        function () {},
      );
    }; // end saveFiltersAs()

    function updateFilterCollection(selectedFilterModels) {
      const { filtersCollection } = selectedFilterModels;
      const { lastCommKey, lastSeenKey } = reservedKeys;

      if ($scope.facets[lastCommKey]) {
        $scope.facets[lastCommKey].forEach((facet) => {
          if (filtersCollection[lastCommKey] && filtersCollection[lastCommKey].id === facet.id) {
            vm.filterModels[lastCommKey][0] = filtersCollection[lastCommKey];
            facet._selected = true;
          } else {
            facet._selected = false;
          }
        });
      }

      if (filtersCollection[lastSeenKey]) {
        const lastSeenFilter = [filtersCollection[lastSeenKey]];

        $scope.facets.lastSeen = lastSeenFilter;
        vm.filterModels.lastSeen = lastSeenFilter;
      }
    }
  }
}
